import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const stretch = keyframes`
  0%, 40%, 100% {
    transform: scale3d(1, 0.4, 1);
  }
  20% {
    transform: scale3d(1, 1, 1);
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: ${({ height }) => height || '50'}px;
  width: 100%;
  margin: ${({ noMargin }) => noMargin ? '0' : '30px auto'};
`
const Bar = styled.div`
  height: 100%;
  width: 6px;
  margin: 0px 1.5px;
  animation: ${stretch} 1.2s infinite ease-in-out;
  animation-delay: ${ props => -1.2 + props.number * .1 }s;
  background: ${({ color }) => color};
`

export default class Loader extends React.Component {
  static propTypes = {
    number: PropTypes.number.isRequired
  }
  renderBars = () => {
    const { number, color = '#3399CC' } = this.props

    return [...Array(number).keys()].map(num => <Bar key={num} number={num} color={color} />)
  }
  render() {
    return (
      <Container {...this.props} >
        {this.renderBars()}
      </Container>
    )
  }
}